(function ($) {
    $(document).ready(function () {
        // Check if either of the rating sections is present
        if ($('.star-rating-content').length > 0 || $('.rating-stars').length > 0) {

            // Define API URL and other data for the request
            var apiUrl = '/api/rating/GetRating';
            var pageId = $('#ratingpageID').attr('data-rating');
            var avglimit = $('#ratingLimitID').attr('data-average');
            var Domain = document.location.hostname;
            var VisitorId = $('#visitorID').attr('data-visitor');
            var Language = $('#contextLangID').attr('data-clang');
            var PH6Code = $("#productName").attr("data-product");
            var country = $("#productCountry").attr("data-product");

            // Prepare the request data
            var ratingData = {
                Domain: Domain,
                VisitorId: VisitorId,
                Language: Language,
                pageId: pageId,
                country: country,
                PH6Code: PH6Code
            };

            // Make AJAX request to fetch the rating data
            $.ajax({
                type: 'POST',
                url: apiUrl,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(ratingData),
                success: function (data, status, xhr) {
                    if (!data || Object.keys(data).length === 0) {
                        console.warn("Empty or missing response from server.");
                        return;
                    }
                    // Handle if there is a .star-rating-content section
                    if ($('.star-rating-content').length > 0) {
                        var userRating = data.UserRating;
                        var avgRating = data.AverageRating;
                        var totalsubmissions = data.TotalSubmissions;

                        // Check if the visitor has already rated
                        if (data.VisitorId === VisitorId) {
                            if (userRating !== 0) {
                                var stars = $(".star-rating input.star").toArray().reverse();
                                var rating = Math.round(avgRating);
                                stars[rating - 1].checked = true;
                                $(".star-rating label").css("pointer-events", "none");
                            }
                        } else {
                            // Reset all star ratings if not the same visitor
                            var inputstars = $(".star-rating input.star");
                            for (var i = 0; i < inputstars.length; i++) {
                                inputstars[i].checked = false;
                            }
                        }

                        // Update average rating and submission count
                        $('.avg-rating').text(avgRating);
                        $('.total-submissions').text(totalsubmissions);
                    }
                    // Handle if there is a .rating-stars section
                    else {
                        var isShowrate = false;
                        var avrate = data.AverageRating;
                        var pagerate = data.UserRating;
                        var votelimit = data.TotalSubmissions;

                        // Show rating if submissions are above the limit
                        if (votelimit >= avglimit) {
                            isShowrate = true;
                        }

                        if (isShowrate) {
                            $(".rating-stars__average-wrap").show();
                            $(".rating-stars__average-number").text(avrate);
                        }

                        // Check if the current visitor has rated this page
                        if (VisitorId === data.VisitorId) {
                            var x = $("input.star").toArray().reverse();
                            if (pagerate !== 0) {
                                x[pagerate - 1].checked = true;
                            }
                            $(".star__label").css("pointer-events", "none");
                            $(".rating-stars__title").text($(".rating-stars__title").data("confirmation-message"));
                        } else {
                            // Reset all star ratings if not the same visitor
                            var input_star = $("input.star");
                            for (var k = 0; k < input_star.length; k++) {
                                input_star[k].checked = false;
                            }
                        }
                    }
                },
                error: function (xhr, status, error) {
                    console.error("Error fetching rating data: " + error);
                }
            });
        }
    });
}(window.jQuery));


(function ($) {
    $(document).ready(function () {
        // Cache DOM elements to avoid repeated queries
        var $starRatingContent = $('.star-rating-content');
        var $ratingStars = $('.rating-stars');
        var $starLabels = $('.star__label');
        var $avgRatingText = $('.avg-rating');
        var $totalSubmissions = $('.total-submissions');
        var $ratingPageId = $('#ratingpageID');
        var $ratingLimitId = $('#ratingLimitID');
        var $visitorId = $('#visitorID');
        var $contextLangId = $('#contextLangID');
        var $productName = $("#productName");
        var $productCountry = $("#productCountry");
        var $ratingStarsTitle = $(".rating-stars__title");
        var $ratingStarsAverageWrap = $(".rating-stars__average-wrap");
        var $ratingStarsAverageNumber = $(".rating-stars__average-number");

        // Function to attach the click event to the rating elements
        function attachRatingEvent() {
            $('.star-rating input[type=radio], .star__label').on('click', function () {
                addRating($(this));
            });
        }

        function addRating($element) {
            // Calculate the rating value (6 - the value of the clicked rating)
            var ratingValue = 6 - parseInt($element.val() || $element.attr('data-rating'));

            // Collect all required data into the bodyObj
            var bodyObj = {
                Rating: ratingValue,
                PageUrl: document.location.pathname,
                SiteDomain: document.location.hostname,
                PageItemId: $ratingPageId.data('rating'),
                VisitorId: $visitorId.data('visitor'),
                PageLanguage: $contextLangId.data('clang').toLowerCase(),
                Name: $productName.data('product'),
                Country: $productCountry.data('product')
            };

            // Send the rating data via AJAX
            $.ajax({
                type: 'POST',
                url: '/api/rating/AddRating',
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(bodyObj),
                success: function (data) {
                    if (!data || Object.keys(data).length === 0) {
                        console.warn("Empty or missing response from server.");
                        return;
                    }

                    if ($starRatingContent.length > 0) {
                        // Update the average rating and total submissions
                        $avgRatingText.text(data.AverageRating);
                        $totalSubmissions.text(data.TotalSubmissions);
                        $(".star-rating label").css("pointer-events", "none");
                    } else if ($ratingStars.length > 0) {
                        // Handle the average rating display
                        var isShowRate = data.TotalSubmissions >= $ratingLimitId.data('average');
                        if (isShowRate) {
                            $ratingStarsAverageWrap.show();
                            $ratingStarsAverageNumber.text(data.AverageRating);
                        }
                        $starLabels.css("pointer-events", "none");
                        $ratingStarsTitle.text($ratingStarsTitle.data("confirmation-message"));
                    }
                },
                error: function (xhr, status, error) {
                    console.error("Error submitting rating:", error);
                }
            });
        }

        // Attach event listeners when document is ready
        if ($starRatingContent.length > 0 || $ratingStars.length > 0) {
            attachRatingEvent();
        }
    });
}(window.jQuery));